module.exports = __webpack_public_path__ + "static/img/OOIAT20240824.a209c54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/OOIAT20240824.jpg
// module id = lkyU
// module chunks = 1